import React from 'react';
import Head from 'next/head';
import PropTypes from 'prop-types';

import { cleanTag } from '~/utils/helpers';

const HeadTag = props => {
  const { title = "TakeMeTour - See Thailand through the local's eyes", keywords, description = 'Book personal 1-day tours with Local Experts. Enjoy the largest collection of 1-day tours in Thailand right at your fingertips.', image, siteName, extras } = props;
  return (
    <Head>
      <title>{title}</title>
      <meta property="og:title" content={title} />
      <meta name="description" content={cleanTag(description)} />
      <meta property="og:description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      {image && <meta property="og:image" content={image} />}
      {siteName && <meta property="og:site_name" content={siteName} />}
      {extras && extras.length > 0 && extras}
    </Head>
  );
};

HeadTag.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  keywords: PropTypes.string,
  image: PropTypes.string,
  siteName: PropTypes.string,
  extras: PropTypes.array
};

export default HeadTag;
